
const history = require('history').createHashHistory

export default history
